import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { inject } from '@angular/core';
import { MediumService, PaginatedMediumDTO } from '@api';

interface MediumState {
  paginatedMedium: PaginatedMediumDTO | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: MediumState = {
  paginatedMedium: null,
  isLoading: false,
  error: null,
};

export const MediumStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),

  withMethods((store) => {
    const mediumService = inject(MediumService);

    return {
      fetchMediums(page?: number, size?: number, sort?: string) {
        patchState(store, () => ({
          isLoading: true,
          error: null,
        }));

        mediumService.getMediums(page, size, sort).subscribe({
          next: (mediums: PaginatedMediumDTO) => {
            const mockMedium =
              mediums?.elements.length > 0
                ? mediums
                : {
                    page: {
                      size: 10,
                      number: 10,
                      totalPages: 10,
                      totalElements: 10,
                    },
                    elements: [
                      {
                        name: 'Medium 1',
                        customsTariffNumber: 1234,
                        id: '1234',
                      },
                      {
                        name: 'Medium 2',
                        customsTariffNumber: 5678,
                        id: '5678',
                      },
                    ],
                  };
            patchState(store, () => ({
              paginatedMedium: mockMedium,
              isLoading: false,
            }));
          },
          error: (err) => {
            patchState(store, () => ({
              isLoading: false,
              error: err?.message || 'Failed to fetch Medium.',
            }));
          },
        });
      },
    };
  }),
);
